import { Injectable } from '@angular/core';
import { Utils } from 'src/app/utils/utilities';
// import * as moment from 'moment';
import * as moment from 'moment-timezone';

@Injectable()
export class ValidationService {
  public isValid: boolean;
  public friendForm: any;
  public errorResponse: any;
  public deliveryDate: any;

  constructor() {
    this.isValid = false;
    this.friendForm = {
      friendEmail: '',
      friendEmailConfirm: '',
      friendName: '',
      friendNote: '',
    };
    this.errorResponse = {};
    this.deliveryDate = '';
  }

  resetDataFriendForm() {
    this.friendForm = {
      friendEmail: '',
      friendEmailConfirm: '',
      friendName: '',
      friendNote: '',
    };
  }

  setIsValid(value: boolean) {
    this.isValid = value;
  }

  setErrorResponse(error) {
    this.errorResponse = { ...error };
    console.log('this.errorResponse:', this.errorResponse);
  }

  validateEmail(data: any) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data)) {
      return true;
    }

    return false;
  }

  confirmEmail(email: any, emailConfirm: any) {
    let str1 = email.toLowerCase();
    let str2 = emailConfirm.toLowerCase();

    if (str1 === str2) {
      return true;
    }

    return false;
  }

  checkNull(data: any) {
    if (data.trim() !== '') {
      return true;
    }

    return false;
  }

  checkLength(data: any, lengthValid: number) {
    if (this.checkNull(data)) {
      if (data.trim().length > lengthValid) {
        return false;
      }

      return true;
    }

    return true;
  }

  checkValidName(data: any) {
    if (this.checkNull(data)) {
      if (!/^\D.*[^.\d]$/.test(data.trim())) {
        return false;
      }

      return true;
    }

    return true;
  }

  setDeliveryDateData(value?) {
    if (value !== '') {
      const zoneName = moment.tz.guess();
      console.log('------ Guessed current locale timezone: ', zoneName);

      this.deliveryDate = moment
        .tz(this.deliveryDate, zoneName)
        .set({ hour: 8, minute: 0, second: 0 })
        .format('YYYY-MM-DDTHH:mm:ssZZ');
      console.log('------ constructed date by local timezone: ', this.deliveryDate);
    } else {
      this.deliveryDate = '';
    }
  }
}
